import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { RestClientList } from '@elderbyte/ngx-starter'
import { PackageType } from './package-type'
import { environment } from '../../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class PackageTypeService extends RestClientList<PackageType, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/package-kinds', http)
  }
}
